import React, { CSSProperties } from 'react';
import { useStyles } from './ProcessChart.styles';
import { useLayoutContext } from '../../../Context/Layout.context';

export interface ProcessChartValue {
  value: number;
  color: string;
}

export interface ProcessChartProps {
  kkProgress: ProcessChartValue;
  pzwoProgress: ProcessChartValue;
  zwoReady: ProcessChartValue;
  total: ProcessChartValue;
}

const ProcessChart: React.FC<ProcessChartProps> = ({ kkProgress, pzwoProgress, zwoReady, total }) => {
  const classes = useStyles();
  const kkWidth = Math.min(1, kkProgress.value / total.value) * 100;
  const pzwoWidth = Math.min(1, pzwoProgress.value / total.value) * 100;
  const zwoReadyWidth = Math.min(1, zwoReady.value / total.value) * 100;
  const totalWidth = 100;

  const { highContrastMode } = useLayoutContext();

  const getAdditionalStyles = (width: number): CSSProperties => {
    const result: CSSProperties = {};

    if (width === 100) {
      result.borderRadius = '5px 5px 5px 5px';
    } else if (width === 0) {
      result.border = 'none';
    }
    return result;
  };

  return (
    <>
      <div className={classes.chart}
      style={{ border: highContrastMode ? 'solid 1px #FFFFFF' : 'none', borderRadius: highContrastMode ? '5px' : ''   }}
      >
        <div
          className={classes.total}
          style={{ backgroundColor: total.color, width: `calc(${totalWidth}% - 3px)` }}
        ></div>
        <div
          className={classes.zwoReady}
          style={{ backgroundColor: zwoReady.color, width: `${zwoReadyWidth}%`, ...getAdditionalStyles(zwoReadyWidth) }}
        ></div>
        <div
          className={classes.pzwo}
          style={{ backgroundColor: pzwoProgress.color, width: `${pzwoWidth}%`, ...getAdditionalStyles(pzwoWidth) }}
        ></div>
        <div
          className={classes.kk}
          style={{ backgroundColor: kkProgress.color, width: `${kkWidth}%`, ...getAdditionalStyles(kkWidth) }}
        ></div>
      </div>
    </>
  );
};

export default ProcessChart;
